// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3imIE","footer":"Form_footer__1ef4a"};